module.exports = "/images/emptySale.svg";